export { AppTable } from './AppTable';


// WEBPACK FOOTER //
// ./src/components/AppTable/index.tsx